
import { Box } from '@mui/material'
import { BoxFC, BoxFR } from 'components/BoxCustom'
import ComboBox from 'components/ComboBox'
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand'
import React, { useCallback, useState, useContext, useEffect } from 'react'
import { GlobalStateContext } from 'contexts/GlobalStateContext'
import SearchButton from 'components/buttons/SearchButton'
import ClearButton from 'components/buttons/ClearButton'
import { initFilterData, clearFilterData } from './initData'
import { addIdForDataGrid } from 'utils'
import { oilChangeApiNm } from './constant'
import AddButton from 'components/buttons/AddButton'
import OilChangeDialog from './OilChangeDialog'
import { oilChangeColumns } from './columns'
import { DesktopDatePicker } from '@mui/x-date-pickers-pro'
import { TextField } from '@mui/material'
import dayjs from 'dayjs'

const sparePartApiNm = { getSparePart: "/spare-part/getSparePart" }

let selectedId = null
let lastFilter = null

const OilChangeManagement = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [sparePartCombo, setSparePartCombo] = useState([])

  const getData = useCallback((filter) => {
    ax.post(oilChangeApiNm.getOilChange, filter).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'SpTrnsId'))
        lastFilter = filter
      }
    })
  }, [ax])

  const handleCellClick = useCallback((params) => {
    if (params.field === 'ShowDetail') {
      selectedId = params.id
      setDialogOpen(true)
    }
  }, [])

  const handleRowDoubleClick = useCallback((params) => {
    selectedId = params.id
    setDialogOpen(true)
  }, [])

  const onFinish = useCallback(() => {
    getData(lastFilter)
  }, [getData])

  const handleAdd = useCallback(() => {
    selectedId = null
    setDialogOpen(true)
  }, [])

  useEffect(() => {
    getData({ ...initFilterData })
    ax.post(sparePartApiNm.getSparePart, { IsActv: 1, SpTypId: 1 }).then(value => {
      if (value.data) {
        setSparePartCombo(value.data.map(item => ({ id: item.SpId, label: `${item.SpCd ? item.SpCd + ' - ' : ''}${item.SpNm}`, UntPr: item.UntPr })))
      }
    })
  }, [getData, ax])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        <AddButton onClick={handleAdd}>เพิ่มรายการ</AddButton>
        <Box flex={1} />
        <ComboBox
          options={msData.truckCombo || []}
          label="รถ"
          selectedId={filterData.TukId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, TukId: id }))}
          sx={{ width: 150 }}
        />
        <ComboBox
          options={sparePartCombo}
          label="น้ำมัน"
          selectedId={filterData.SpId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, SpId: id }))}
          sx={{ width: 180 }}
        />
        <DesktopDatePicker
          label="ตั้งแต่"
          inputFormat="DD/MM/YYYY"
          value={filterData.ChgDteSt}
          onChange={(v) => setFilterData(o => ({ ...o, ChgDteSt: v ? dayjs(v).format("YYYY-MM-DD") : null }))}
          renderInput={(params) => <TextField size="small" sx={{ width: 150 }} {...params} />}
        />
        <DesktopDatePicker
          label="ถึง"
          inputFormat="DD/MM/YYYY"
          value={filterData.ChgDteEn}
          onChange={(v) => setFilterData(o => ({ ...o, ChgDteEn: v ? dayjs(v).format("YYYY-MM-DD") : null }))}
          renderInput={(params) => <TextField size="small" sx={{ width: 150 }} {...params} />}
        />
        <SearchButton onClick={() => getData(filterData)} />
        <ClearButton onClick={() => setFilterData({ ...clearFilterData })} />
      </BoxFR>
      <Box height='100%'>
        <DataGridCellExpand
          hideFooter
          rows={dataTable}
          columns={oilChangeColumns}
          onRowDoubleClick={handleRowDoubleClick}
          onCellClick={handleCellClick}
        />
      </Box>
      <OilChangeDialog
        selectedId={selectedId}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        onFinish={onFinish}
        sparePartCombo={sparePartCombo}
      />
    </BoxFC>
  )
}

export default OilChangeManagement
